import { getMoney } from '@hlj/hlj-utils'
import React from 'react'
import Attachments from '@common/Attachments'
import { Flex } from 'hljd'
import style from './style.module.less'

export default [
  {
    dataIndex: 'billNo',
    title: '账单编号',
    render: (o, { billNo, statusName, status, refundStatus }) => {
      return (
        <Flex sp>
          <div>{billNo}</div>
          <span style={{ color: '#47D788' }}>状态：{statusName}</span>
        </Flex>
      )
    }
  },
  {
    dataIndex: 'money',
    title: '服务费金额',
    render: (o, { money }) => {
      return getMoney(money)
    }
  },
  {
    dataIndex: 'remark',
    title: '费用备注',
    render: (o, { remark, attachments }) => {
      return (
        <div>
          <div>{remark}</div>
          <Attachments showUpload={false} value={attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: 'refundRemark',
    title: '退款原因',
    hidden: refundRemark => {
      return !refundRemark
    },
    className: style.refundRemark,
    render: (o, { refundRemark, refundAttachments }) => {
      return (
        <div>
          <div>{refundRemark}</div>
          <Attachments
            showUpload={false}
            value={refundAttachments}
            style={{ marginTop: 9 }}
          />
        </div>
      )
    }
  },
  {
    dataIndex: ['merchantSupport', 'nick'],
    title: '申请人'
  },
  {
    dataIndex: 'createdAt',
    title: '申请时间'
  }
]
